import {
    Site,
    OpenAPI,
    SiteService
} from '../openapi';
import { ApiResult } from '../openapi/core/ApiResult';
import { PropertyInfo } from '../openapi/models/PropertyInfo';

const { get, get1, put, getTotalCount, descriptions, post, type, propertyInfo } = SiteService;

OpenAPI.BASE = process.env.REACT_APP_API_ENDPOINT as string;

export const getSites = async (token: string, range: string, filter?: Record<string, string>, search?: Record<string, string>) => {
    const sites: ApiResult = await get(token, range, filter, search);
    return sites;
};

export const getSiteCount = async (token: string, filter?: Record<string, string>, search?: Record<string, string>): Promise<string> => {
    const result: string = await getTotalCount(token, filter, search);
    const count = result.split('/')[1];
    return count;
};

export const getSiteById = async (token: string, id: string): Promise<Site> => {
    return await get1(token, id);
};

export const updateSite = async (
    token: string,
    id: number,
    site: Site
): Promise<number> => {
    const s = { ...site };
    s.propertyNames = {};
    return await put(token, id, s);
};

export const getDescriptions = async (token: string): Promise<Record<string,string>> => {   
    return await descriptions(token);
};

export const getSiteType = async (token: string, siteId: string): Promise<string> => {   
    return await type(token, siteId);
};

export const addSite = async (token: string, newSite: Site): Promise<number> => {
    return await post(token, newSite);
};

export const getPropertyInfo = async (token: string): Promise<Record<string, PropertyInfo>> => {
    return await propertyInfo(token);
};